export interface RegistrationResumeChoiceDismissal {
  actorUserId: string | null;
  actorEmail: string | null;
  dismissedAt: string;
}

const REGISTRATION_RESUME_CHOICE_DISMISSAL_KEY = 'sportbook.workflow.registrationResumeChoice.dismissal';

function hasSessionStorage(): boolean {
  return typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined';
}

function normalizeActorEmail(actorEmail: string | null | undefined): string | null {
  return actorEmail ? actorEmail.toLowerCase() : null;
}

function readDismissal(): RegistrationResumeChoiceDismissal | null {
  if (!hasSessionStorage()) {
    return null;
  }

  const raw = window.sessionStorage.getItem(REGISTRATION_RESUME_CHOICE_DISMISSAL_KEY);
  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw) as RegistrationResumeChoiceDismissal;
  } catch {
    window.sessionStorage.removeItem(REGISTRATION_RESUME_CHOICE_DISMISSAL_KEY);
    return null;
  }
}

export function markRegistrationResumeChoiceDismissed(input: {
  actorUserId?: string | null;
  actorEmail?: string | null;
}): void {
  if (!hasSessionStorage()) {
    return;
  }

  const dismissal: RegistrationResumeChoiceDismissal = {
    actorUserId: input.actorUserId ?? null,
    actorEmail: normalizeActorEmail(input.actorEmail),
    dismissedAt: new Date().toISOString(),
  };

  window.sessionStorage.setItem(REGISTRATION_RESUME_CHOICE_DISMISSAL_KEY, JSON.stringify(dismissal));
}

export function clearRegistrationResumeChoiceDismissal(): void {
  if (!hasSessionStorage()) {
    return;
  }

  window.sessionStorage.removeItem(REGISTRATION_RESUME_CHOICE_DISMISSAL_KEY);
}

export function isRegistrationResumeChoiceDismissed(input: {
  actorUserId?: string | null;
  actorEmail?: string | null;
}): boolean {
  const dismissal = readDismissal();
  if (!dismissal) {
    return false;
  }

  const actorUserId = input.actorUserId ?? null;
  const actorEmail = normalizeActorEmail(input.actorEmail);

  if (dismissal.actorUserId && actorUserId && dismissal.actorUserId === actorUserId) {
    return true;
  }

  if (dismissal.actorEmail && actorEmail && dismissal.actorEmail === actorEmail) {
    return true;
  }

  return false;
}
